import { useCallback } from 'react';
import { useTranslation } from '@aimsos/i18n';
import { SlideOut, SlideOutHeader } from '@aimsos/ui';

import { useCreateDriveFolder } from '../../../hooks/useCreateDriveFolder.js';
import NewFolderForm from './NewFolderForm.jsx';

import { FolderPlus } from 'lucide-react';

/**
 * "New folder · In <folder>" (CT-5717) — entity-scoped, not Governance Studio's
 * folder creation. Mounted only while open, so each opening starts clean.
 */
function NewFolderSlideOut({ entityType, entityId, parentId, parentName, onClose, onCreated }) {
  const { t } = useTranslation('unified-profiles');
  const title = t('knowledge.drive.newFolder.title');

  const handleCreated = useCallback(() => {
    onCreated?.();
    onClose();
  }, [onCreated, onClose]);
  const { create, creating } = useCreateDriveFolder({ entityType, entityId, onCreated: handleCreated });
  const handleSubmit = useCallback((values) => create({ ...values, parentId }), [create, parentId]);

  const renderHeader = useCallback(
    (titleId) => (
      <SlideOutHeader
        titleId={titleId}
        title={title}
        subtitle={t('knowledge.drive.newFolder.in', { name: parentName })}
        icon={FolderPlus}
        size="M"
        showClose
        onClose={onClose}
      />
    ),
    [title, parentName, onClose, t],
  );

  return (
    <SlideOut isOpen onClose={onClose} renderHeader={renderHeader} size="M" ariaLabel={title}>
      <NewFolderForm creating={creating} onSubmit={handleSubmit} onCancel={onClose} />
    </SlideOut>
  );
}

export default NewFolderSlideOut;
